// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Tag
} from '@arco-design/web-react';

import './index.scss';

import { get, post } from '../requestNew';
import { Item, TypeItem } from './types';

const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

const colors = [
  'red',
  'gold',
  'lime',
  'green',
  'purple',
  'cyan',
  'blue',
  'orangered',
  'arcoblue',
  'pinkpurple',
  'orange',
  'magenta'
];
const colorLength = colors.length;

function SectorsManagement() {
  const navigate = useNavigate();
  const [form] = Form.useForm<Item>();
  const [formSearch] = Form.useForm<Item>();
  const [options, setOptions] = useState<[]>([]);
  const [optionsMap, setOptionsMap] = useState<Record<string, any>>({});
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);

  const formRef = useRef<any>({});

  const columns: TableColumnProps[] = [
    {
      title: '排序Id',
      width: 80,
      dataIndex: 'id'
    },
    {
      title: '概念板块名称',
      dataIndex: 'name',
      width: 180
    },
    {
      title: '行业大类归属',
      dataIndex: 'industryName',
      width: 180,
      render: (text, record) => (
        <Tag bordered color={optionsMap[record.industryCode].color}>
          {text}
        </Tag>
      )
    },
    {
      title: '当前绑定成分个股',
      dataIndex: 'stockCount',
      width: 180,
      render: text => <Button type="text" onClick={() => jump()}>{`${text || 0}支`}</Button>
    },
    {
      title: '启用',
      dataIndex: 'status',
      width: 80,
      render: (text, record) => <Switch checked={text === 1} onChange={() => changeStatus(record)} />
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            编辑
          </Button>
          {/* <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger">
              删除
            </Button>
          </Popconfirm> */}
        </>
      )
    }
  ];

  const jump = () => {
    navigate('/stock-management');
  };

  const getTypes = () => {
    get<any>('/marketIndustry/level1/list')
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const list = (data || []).map((item: TypeItem) => {
            const { code, name } = item;
            return { label: name, value: code };
          });
          setOptions(list);

          const map: Record<string, any> = {};
          list.forEach((item: { value: string; label: string }, idx: number) => {
            map[item.value] = { name: item.label, color: colors[idx % colorLength] };
          });
          setOptionsMap(map);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const getList = (page?: { pageNum: number; pageSize: number }) => {
    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize,
      ...page
    };

    get<any>('/marketSector/admin/page', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const search = () => {
    setPageNum(1);
    setPageSize(20);
    const params = {
      pageNum: 1,
      pageSize: 20
    };
    getList(params);
  };

  const add = () => {
    formRef.current = {};
    form.resetFields();
    setVisible(true);
  };

  const changeStatus = (record: Item) => {
    post('/marketSector/admin/save', { ...record, status: record.status === 1 ? 0 : 1 })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const edit = (record: Item) => {
    formRef.current = record;
    form.setFieldsValue({ ...record });
    setVisible(true);
  };
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };
  const onOk = () => {
    form.validate().then(values => {
      const data = { ...values, status: 1 };
      post('/marketSector/admin/save', data)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            getList();
            editCancel();
          } else {
            Message.error(message);
          }
        })
        .catch(e => {
          Message.error('网络错误!');
          console.log(e);
        });
      //   });
    });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);
  useEffect(() => {
    getTypes();
  }, []);

  return (
    <div className="sectors table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="板块名称" field="keyword">
            <Input style={{ width: 200 }} allowClear />
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={search}>
              查询
            </Button>
          </FormItem>
          {/* <FormItem>
            <Button type="outline" onClick={handleReset}>
              重置
            </Button>
          </FormItem> */}
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add}>
              新增
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑' : '新增'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        maskClosable={false}
      >
        <Form {...formItemLayout} form={form}>
          <FormItem field="id" hidden>
            <Input placeholder="请输入板块名称" />
          </FormItem>
          <FormItem label="板块名称" field="name" rules={[{ required: true, message: '请输入板块名称' }]}>
            <Input placeholder="请输入板块名称" />
          </FormItem>
          <Form.Item label="分类行业" field="industryCode" rules={[{ required: true, message: '请选择分类行业' }]}>
            <Select placeholder="请选择分类行业" options={options} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default SectorsManagement;
